// extracted by mini-css-extract-plugin
export default {"empty":"list_empty__H0gV6","emptyLink":"list_emptyLink__5a4e+"};